import React from 'react';
import { Link } from '@app/router';

const NavItem = ({ active = false, children, href, isExternal = false }) => {
  if (isExternal) {
    return (
      <a href={href} className={active ? 'active' : undefined}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className={active ? 'active' : undefined}>
      {children}
    </Link>
  );
};

export default NavItem;
